import { render, staticRenderFns } from "./AiModelForm.vue?vue&type=template&id=b034f084&scoped=true&"
import script from "./AiModelForm.vue?vue&type=script&lang=js&"
export * from "./AiModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b034f084",
  null
  
)

export default component.exports